const formatFingerprint = (fingerprint: string) => {
    return fingerprint.toUpperCase()
        .replace(/"/g, '')
        .replace(/(.{4})/g, '$1 ').trim();
}

export const useGpg = () => {
    return {
        formatFingerprint
    }
}
